import React from "react";
import Student from "./Student"
import search from "../helpers/search";

 const Students = ({students, nameInput, tagInput, addNewTag })=> {
    return (
      <React.Fragment>
        {search(students, nameInput, tagInput).map((student) => {
          return <Student key={student.id} addNewTag={addNewTag} studentDetails={student} />
        }
        )}
      </React.Fragment>
    );
  }
  export default Students;
